import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";

import { LoginPage } from "../pages";

export const LoginRouter = () => (
  <Routes>
    <Route path="/login" element={<LoginPage />} />
    <Route path="*" element={<Navigate to="login" />} />
  </Routes>
);
